import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import {
    Box,
    Typography,
    Button,
    TextField,
    Card,
    CardContent,
    Stack,
    Divider,
} from "@mui/material";
import Navbar from "../../Navbar/Navbar";
import baseURL from "../../config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SalarySlip = () => {
    const { contractId } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [files, setFiles] = useState({});
    const [uploadedSlips, setUploadedSlips] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.get(
                    `${baseURL}/api/getStatusAfterForm1DetailsByContractId/${contractId}`,
                    {
                        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
                    }
                );
                setData(res.data);

                const res2 = await axios.get(
                    `${baseURL}/api/uploadSalarySlip/contractId/${contractId}`,
                    {
                        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
                    }
                );
                setUploadedSlips(Array.isArray(res2.data.data) ? res2.data.data : []);
                console.log("Uploaded salary slips:", res2.data.data);

            } catch (err) {
                setError(err.response?.data?.message || "Something went wrong");
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [contractId]);

    const getMonthsBetween = (startDate, endDate) => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        const months = [];

        const current = new Date(start.getFullYear(), start.getMonth(), 1);

        while (current <= end) {
            months.push(new Date(current));
            current.setMonth(current.getMonth() + 1);
        }

        return months;
    };

    if (loading) return <Typography>Loading...</Typography>;
    if (error) return <Typography color="error">{error}</Typography>;

    const startDate = data.coc?.[0]?.Date ? new Date(data.coc[0].Date) : null;
    const endDate = data.signOff?.[0]?.date ? new Date(data.signOff[0].date) : new Date();
    const months = startDate ? getMonthsBetween(startDate, endDate) : [];

    const handleFileChange = (monthKey, e) => {
        setFiles(prev => ({ ...prev, [monthKey]: e.target.files[0] }));
    };

    const handleUpload = async (monthDate) => {
        const monthKey = monthDate.toLocaleString("default", { month: "long", year: "numeric" });

        if (!files[monthKey]) return alert("Please select a file first");

        const selectedDate = files[`${monthKey}_date`];
        if (!selectedDate) return alert("Please select a date for this month");

        const formData = new FormData();
        formData.append("slip", files[monthKey]);
        formData.append("contractId", contractId);
        formData.append("crewId", data.crewId);
        formData.append("crewingAgent", data.contractId.crewingAgent);
        formData.append("VesselOwner", data.contractId.vesselOwner);
        formData.append("date", new Date(selectedDate).toISOString());
        formData.append("creatorId", data.creatorId);
        formData.append("creatorName", data.contractId?.creatorIdWithName?.[0].name);

        try {
            await axios.post(`${baseURL}/api/uploadSalarySlip`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
            toast.success(`Salary slip uploaded for ${monthKey}`);
            window.location.reload();
        } catch (err) {
            console.error(err.response?.data || err.message);
            alert(err.response?.data?.message || "Upload failed");
        }
    };

    return (
        <>
            <Navbar />
            <Box sx={{ p: 4 }}>
                <Typography variant="h4" gutterBottom>
                    Salary Slips
                </Typography>
                {console.log("uploadedSlips", uploadedSlips)}

                {months.map((monthDate, idx) => {
                    const monthKey = monthDate.toLocaleString("default", { month: "long", year: "numeric" });

                    // ✅ Safely check if a slip exists for this month
                    const existingSlip = uploadedSlips.find(slip =>
                        slip.slipMonth?.some(m => {
                            const slipDate = new Date(m.Date);
                            const slipMonthKey = slipDate.toLocaleString("default", { month: "long", year: "numeric" });
                            return slipMonthKey === monthKey;
                        })
                    );

                    const slipMonthData = existingSlip?.slipMonth?.find(m => {
                        const slipDate = new Date(m.Date);
                        const slipMonthKey = slipDate.toLocaleString("default", { month: "long", year: "numeric" });
                        return slipMonthKey === monthKey;
                    });


                    console.log("existingSlip", existingSlip)

                    const year = monthDate.getFullYear();
                    const month = monthDate.getMonth();
                    const minDate = new Date(year, month, 1).toLocaleDateString("en-CA");
                    const maxDate = new Date(year, month + 1, 0).toLocaleDateString("en-CA");

                    return (
                        <Card key={idx} sx={{ p: 2 }}>
                            <CardContent>
                                <Typography variant="h6" gutterBottom>
                                    {monthKey}
                                </Typography>

                                {existingSlip && existingSlip.slipMonth ? (
                                    // ✅ Show the uploaded slip link
                                    <Stack direction="row" spacing={2} alignItems="center">
                                        <Button
                                            variant="outlined"
                                            component="a"
                                            href={`${baseURL}/Documents/vesselUpload/${slipMonthData.slip.filename}`}
                                            target="_blank"
                                        >
                                            View Uploaded Salary Slip
                                        </Button>
                                        <Typography variant="body2" color="green">
                                            Uploaded on: {new Date(slipMonthData.createdAt).toLocaleDateString("en-GB")}
                                        </Typography>
                                    </Stack>
                                ) : (
                                    // ✅ Show upload form if not uploaded yet
                                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems="center">
                                        <TextField
                                            type="date"
                                            label="Select Date"
                                            InputLabelProps={{ shrink: true }}
                                            onChange={(e) =>
                                                setFiles((prev) => ({
                                                    ...prev,
                                                    [`${monthKey}_date`]: e.target.value,
                                                }))
                                            }
                                            inputProps={{ min: minDate, max: maxDate }}
                                            sx={{ minWidth: 150 }}
                                        />

                                        <Button
                                            variant="contained"
                                            component="label"
                                            sx={{ backgroundColor: "#1976d2" }}
                                        >
                                            {files[monthKey]?.name ? files[monthKey].name : "Choose File"}
                                            <input
                                                hidden
                                                type="file"
                                                onChange={(e) => handleFileChange(monthKey, e)}
                                            />
                                        </Button>

                                        <Button
                                            variant="contained"
                                            color="success"
                                            onClick={() => handleUpload(monthDate)}
                                        >
                                            Upload
                                        </Button>
                                    </Stack>
                                )}
                            </CardContent>
                        </Card>
                    );
                })}


            </Box>
            <ToastContainer />
        </>
    );
};

export default SalarySlip;
